import * as React from 'react';
import { PessimizationContainer } from '../PessimizationContainer';
import { PessimizationFlexibleContainer } from '../PessimizationFlexibleContainer';
import { useApplicationContext } from '../../../../../../shared/serp/containers/ApplicationContext';

export const PessimizationTogglerContainer = () => {
  const { config } = useApplicationContext();
  const isFlexibleSanctions = config.get<boolean>('Moderation.CustomSanction.NewModerationInfo.Enabled');

  return isFlexibleSanctions ? <PessimizationFlexibleContainer /> : <PessimizationContainer />;
};

PessimizationTogglerContainer.displayName = 'PessimizationTogglerContainer';
